<template>
    <nav id="navbar">
        <div class="container">
            <router-link to="/" class="nav-brand" tabindex="0">Miałam Zawał</router-link>
            <div class="menu" v-if="showLandingPageMenu === false">
                <router-link class="nav-link important" to="/">Home</router-link>
                <!-- <router-link class="nav-link right important" to="/for-doctors">Dla lekarzy</router-link> -->
            </div>
            <div class="menu" v-if="showLandingPageMenu === true" v-scroll-spy-link
                v-scroll-spy-active="{class: 'active'}">
                <a href="/#" class="nav-link important">Home</a>
                <a href="/#" class="nav-link">Co to jest SCAD?</a>
                <a href="/#" class="nav-link">Objawy</a>
                <a href="/#" class="nav-link">Historie pacjentek</a>
                <a href="/#" class="nav-link">FAQ</a>
                <a href="/#" class="action important">Kontakt</a>
                <!-- <router-link class="nav-link right important" to="/for-doctors">Dla lekarzy</router-link> -->
            </div>
        </div>
    </nav>


</template>
<script>
    export default {
        props: {
            homePage: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            showLandingPageMenu: function () {
                return ['/'].includes(this.$route.path)
            }
        },
        mounted() {

            const scene2 = this.$scrollmagic.scene({
                    // ID of element where animation starts
                    offset: 0,
                    // {0,0.5,1} - animations starts from {top,center,end} of window
                    triggerHook: 1,

                    // Duration of animation
                    duration: 300
                })
                // Declaration of animation and attaching to element
                .setTween('#navbar', {
                    css: {
                        background: 'rgb(245,245,245)'
                    }
                })


            // Add Scene to controller
            this.$scrollmagic.addScene(scene2)
        }
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans|Roboto&display=swap');
    @import '../vars.scss';

    nav {
        font-family: 'Josefin Sans';
        padding: 1em 0;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 99;
        background: transparent;

        .container {
            display: flex;
            justify-content: space-between;
            align-items: center;

            @media(max-width: 580px) {
                display: block;
            }
        }

        .menu {
            display: flex;
            align-items: center;
        }

        .nav-brand,
        .nav-link {
            text-decoration: none;
            color: black;
            cursor: pointer;

            &:focus {
                outline: none;
                text-decoration: underline;
            }
        }

        .nav-brand {
            font-size: 1.5em;

        }

        .nav-link {
            padding: 7px;
            margin: 10px;

            &:not(.important) {
                @media(max-width: 900px) {
                    display: none;
                }
            }
        }

        .action {
            all: unset;
            cursor: pointer;
            display: inline-block;
            border: 2px solid $primary;
            padding: 7px;
            margin: 10px;
            border-radius: 2px;
            background: none;

            &:focus {
                outline: none;
                text-decoration: underline;
            }
        }

        .right {
            padding-left: 1em;
            border-left: 2px solid black;
        }

    }
</style>
